import { render, staticRenderFns } from "./controlComponent.vue?vue&type=template&id=0b241e1f&"
import script from "./controlComponent.vue?vue&type=script&lang=js&"
export * from "./controlComponent.vue?vue&type=script&lang=js&"
import style0 from "./controlComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports